import React from 'react';
import { useSelector } from 'react-redux';
import { maintenanceMessageSelector } from '../../selectors/featureFlags';
import styled from '../../theme';
import { themeColor } from '../../theme/helpers';
import { Color } from '../../theme/primaryTheme';

const MaintenanceMessage: React.FunctionComponent = () => {
  const maintenanceMessage = useSelector(maintenanceMessageSelector);

  if (!maintenanceMessage) {
    return null;
  }

  return (
    <ContentWrapper>
      <MessageWrapper>
        <MessageText dangerouslySetInnerHTML={{ __html: maintenanceMessage }} />
      </MessageWrapper>
    </ContentWrapper>
  );
};

const ContentWrapper = styled.div`
  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: rgb(242, 188, 53);
  background: rgb(255, 255, 255);
  margin-top: 3px;
  margin-bottom: 5px;
  border-radius: 4px;
`;

const MessageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  max-width: 1200px;
  margin: 0 auto;
  color: ${themeColor(Color.Primary)};
`;

const MessageText = styled.div`
  margin: 0;
  line-height: 1.6rem;
  text-align: left;
  white-space: pre-wrap;
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 400;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export default MaintenanceMessage;
